if (!customElements.get('af-cart-cross-sell')) {
  customElements.define('af-cart-cross-sell', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.observer.disconnect();
          this.load();
        }
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }

    async fetchCards(url) {
      const response = await fetch(url, { signal: this.controller.signal });
      if (!response.ok) throw new Error('Cross-sell request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return [...(doc.querySelector('template[data-af-cross-sell-candidates]')?.content.querySelectorAll('[data-product-id]') || [])];
    }

    async load() {
      if (this.loading) return;
      this.loading = true;
      try {
        // Related products come first; the live price-filtered catalog fills any gaps.
        const results = await Promise.allSettled([
          this.fetchCards(this.dataset.recommendationsUrl),
          this.fetchCards(this.dataset.searchUrl),
        ]);
        if (!this.isConnected || this.controller.signal.aborted) return;
        const seen = new Set();
        const cards = results.flatMap((result) => result.status === 'fulfilled' ? result.value : [])
          .filter((card) => {
            const price = Number(card.dataset.price);
            if (seen.has(card.dataset.productId) || !(price > 0 && price < 500)) return false;
            seen.add(card.dataset.productId);
            return true;
          }).slice(0, 8);
        if (!cards.length) {
          this.hidden = true;
          return;
        }
        const slider = this.querySelector('.swiper');
        this.querySelector('.swiper-wrapper').replaceChildren(...cards);
        this.querySelector('.af-cart-cross-sell__loading').hidden = true;
        slider.hidden = false;
        this.querySelector('.af-cart-cross-sell__nav').hidden = cards.length < 2;
        this.carousel = new FoxTheme.Carousel(slider, {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: false,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
          navigation: {
            prevEl: this.querySelector('.af-cart-cross-sell__prev'),
            nextEl: this.querySelector('.af-cart-cross-sell__next'),
          },
        });
        this.carousel.init();
      } catch (error) {
        // Recommendations must never prevent the customer from checking out.
        this.hidden = true;
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.carousel?.slider?.destroy(true, true);
      this.carousel = null;
      this.loading = false;
    }
  });
}
